export default __webpack_public_path__ + "static/meet-john-5-88fcfc62b19bd715334f4761f4b7cf77.webp";